import React, { useState, useRef, useEffect } from "react";
import Reactselect from "react-select";

export default function FilterDropdown({
  id,
  value,
  options,
  placeholder,
  onChange,
  label,
  reactSelectCustomStyles,
  zIndex,
  isOpen,
  onClick,
  onToggle
}) {
  const [menuIsOpen, setMenuIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Update local state when controlled state changes
  useEffect(() => {
    if (isOpen !== undefined) {
      setMenuIsOpen(isOpen);
    }
  }, [isOpen]);

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setMenuIsOpen(false);
      if (onToggle) onToggle(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleChange = (selectedOption) => {
    onChange(selectedOption);
    setMenuIsOpen(false);
    if (onToggle) onToggle(false);
  };

  const toggleMenu = (e) => {
    e.preventDefault();
    const newMenuState = !menuIsOpen;
    setMenuIsOpen(newMenuState);
    
    // Notify parent about the toggle
    if (onToggle) onToggle(newMenuState);
    
    // Also call onClick if provided (for backward compatibility)
    if (onClick) onClick();
  };

  return (
    <div
      ref={dropdownRef}
      className="grid-item"
      style={{
        flexBasis: "2.4%",
        fontSize: "14px",
        marginBottom: "10px",
        zIndex: zIndex,
      }}
    >
      <div className="dropdown-label">{label}</div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          paddingRight: "10px",
        }}
        onMouseDown={toggleMenu}
      >
        <Reactselect
          id={id}
          isClearable
          name={placeholder}
          placeholder={placeholder}
          styles={reactSelectCustomStyles}
          value={value}
          options={options}
          onChange={handleChange}
          classNamePrefix="react-select"
          menuIsOpen={menuIsOpen}
          onMenuOpen={() => {
            setMenuIsOpen(true);
            if (onToggle) onToggle(true);
          }}
          onMenuClose={() => {
            setMenuIsOpen(false);
            if (onToggle) onToggle(false);
          }}
        />
      </div>
    </div>
  );
}